//Redux Toolkit
import { createSelector } from "@reduxjs/toolkit";

//Settings
import { _resultsPerPage } from "../../../constants/paginaton-settings";
import { _mobileResultsPerPage } from "../../../constants/paginaton-settings";

//Selectors
import { selectFacetedResults } from "../facets/select-faceted-results";

//Util
import { getTotalPages } from "../../../functions/pagination/get-total-pages";
import { selectIsMobile } from "../../../../system/redux/selectors/select-is-mobile";

/** Returns the total number of pages of results in the matched result list. */
export const selectTotalPages = createSelector(
	[selectFacetedResults, selectIsMobile],
	(results, isMobile) => {
		let numberOfResultsPerPage = _resultsPerPage;
		if (isMobile) {
			numberOfResultsPerPage = _mobileResultsPerPage;
		}

		return getTotalPages(
			results?.MatchedResults?.length,
			numberOfResultsPerPage,
		);
	},
);
